import React from "react";
import DevelopBannerSection from "../components/Homepage/DevelopPageComponents/DevelopBannerSection";
import Industries from "../components/Homepage/IndustriesSection/Industries";
import VntWork from "../components/ServicesPageComponents/VntWork";
import DevDiff from "../components/Homepage/DevelopPageComponents/DevDiff";
import IndusExpert from "../components/IndustriesPageComponents/IndusExpert";
import BlogSection from "../components/BlogPosts/BlogSection";
import {
  block10,
  block11,
  block12,
  block7,
  block8,
  block9,
  float1,
  float2,
  itconsultancy1,
  itconsultancy2,
  sanyogprofileImg,
} from "../components";
import IotProcessBlock from "../components/ServicesPageComponents/IotProcessBlock";
function ItConsultancy() {
  return (
    <>
      <div className="devlopPage" id="devlopPage">
        <div className="devTopSection consultancyBg">
          <DevelopBannerSection
            line1="Transform Your "
            line2="Business Digitally"
            line3="With Our Services"
            BannerPara="We specialize in delivering complex IT projects, cloud adoption, disaster recovery, enterprise mobility management, cyber security strategy, and specialized IT support. Our proven and effective approach to IT Consultancy ensures your business achieves its technology goals efficiently and securely."
          />
          <div className="shapeSvg">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15002 2408">
              <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer" />
                <path
                  className="fil0"
                  d="M14999.66 160.41l0 2250.5 -15002 0 0 -2408.48c4.48,15.46 34.05,38.31 47.09,51.36 18.3,18.3 33.31,33.31 51.61,51.61l377.15 322.94c339.34,254.69 723.38,451.6 1129.12,576.25 740.24,227.38 1518.28,209.44 2250.74,-34.78 297.55,-99.2 684.02,-289.57 933.07,-476.11 87.62,-65.63 227.27,-165.69 307.34,-240.17 31.42,-29.23 114.35,-99.39 131.22,-124.58 20,4.66 99.59,47.55 124.17,59.83 42.41,21.2 81.55,40.72 122.67,61.33l125.61 58.39c133.82,59.52 249.76,112.63 391.76,169.22 238.34,95 587.91,216.82 832.54,284.94 200.63,55.86 382.28,106.97 590.69,154.3 1557.59,353.7 3775.68,425.94 5382.01,17.95 25.54,-6.48 49.29,-10.39 73.59,-16.17l373.43 -93.31c198.88,-54.19 343.18,-97.87 536.61,-159.02l312.66 -109.2c47.88,-17.88 90.5,-33.57 136.53,-51.96 82.88,-33.12 316.41,-125.5 392.57,-163.92l128.78 -59.7c23.6,-10.77 225.99,-115.13 251.04,-121.22z"
                />
              </g>
            </svg>
          </div>
        </div>
        <section className="wntWorkSection iotProcessSection">
          <span className="elm1 elm"></span>
          <span className="elm2 elm"></span>
          <span className="elm3 elm"></span>
          <span className="elm4 elm"></span>
          <div className="container">
            <VntWork
              subText="Our"
              mainText="Services"
              paratext="Transform your business digitally with our bespoke IT Consulting services. At Version Next Technologies, we believe in tailoring our solutions to fit your unique business requirements."
            />
            <div className="iotPrecessBlock">
              <div className="row justify-content-center">
                <IotProcessBlock
                  imgSrc={block7}
                  title="Complex IT Projects"
                  description="At Version Next Technologies, we strategically design, deliver, and fully support complex IT projects tailored to meet your business needs. Our team of experts possesses a deep understanding of cutting-edge technologies and industry best practices to ensure successful project execution."
                />
                <IotProcessBlock
                  imgSrc={block8}
                  title="Cloud Adoption"
                  description="Embrace the power of the cloud with our Cloud Adoption services. We offer expertise in Software as a Service (SaaS), Private Cloud, and Hybrid Cloud solutions, enabling your organization to scale seamlessly and optimize operations efficiently."
                />
                <IotProcessBlock
                  imgSrc={block9}
                  title="Disaster Recovery and Business Continuity"
                  description="Safeguard your business against unforeseen disasters with our Disaster Recovery and Business Continuity solutions. We ensure your critical data is backed up and accessible, allowing your operations to continue uninterrupted during challenging times."
                />
                <IotProcessBlock
                  imgSrc={block10}
                  title="Enterprise Mobility Management"
                  description="Optimize your workforce's productivity with our Enterprise Mobility Management services. We implement device management solutions that enable secure access to business resources, enhancing collaboration and efficiency while maintaining data security."
                />
                <IotProcessBlock
                  imgSrc={block11}
                  title="Cyber Security Strategy"
                  description="Protect your business data with our comprehensive Cyber Security Strategy. Our experts work tirelessly to identify potential threats, implement robust security measures, and continuously monitor and update your security infrastructure to keep your data safe and secure."
                />
                <IotProcessBlock
                  imgSrc={block12}
                  title="Specialist IT Support"
                  description="Experience peace of mind with our 24-hour specialist IT Support from our large Service Desk. Our skilled technicians are always available to address any IT issues promptly and efficiently, ensuring minimal downtime and maximum productivity for your business."
                />
              </div>
            </div>
          </div>
        </section>
        <section id="industriesSection" className="industriesSection">
          <div className="rightTop"></div>
          <Industries
            char1="Our"
            char2="Services"
            char3="In"
            char4="Industries"
            secPara="We have honed our skills in developing advanced web platforms,
        mobile applications, and intricate systems that align with the
        latest industry trends."
            icon1="health_and_safety"
            cardTitle1="Health and Life Sciences"
            cardDesc1="EHR & EMR, Patient Portals software development services
          for institutions maintaining physical and mental
          well-being: medical, telemedicine."
            cardLink1="#"
            icon2="school"
            cardTitle2="Education"
            cardDesc2="Education app development services provided by Version
          Next empower learning experience for students, teachers,
          and administrations."
            cardLink2="#"
            icon3="account_balance"
            cardTitle3="FinTech"
            cardDesc3="Financial software development services that help automate
          processes, improve transaction security, and put the
          latest technologies for your business."
            cardLink3="#"
            icon4="volunteer_activism"
            cardTitle4="Insurance"
            cardDesc4="Insurance software development services that automate
          processes, improve data security, and help your business
          benefit from the latest technologies."
            cardLink4="#"
            icon5="inventory"
            cardTitle5="Supply Chain & Logistics"
            cardDesc5="We ensure consistent development, scaling, and high
          performance products for supply chain & logistics
          management to meet your corporate goals."
            cardLink5="#"
            icon6="storefront"
            cardTitle6="Digital Retail"
            cardDesc6="Solutions counting customer’s business processes,
          Increasing the performance of customer’s retail software
          by automating manual processes."
            cardLink6="#"
          />
          <div className="leftBtm"></div>
        </section>
        <section id="clientAssists" className="clientAssists">
          <div className="container">
            <div className="sectionTitle">
              <h2>
                Our Proven Approach to{" "}
                <span className="textGrade">IT Consultancy</span>
              </h2>
              <p>
                Our experienced consultants take the time to understand your
                organization's goals, challenges, and current IT landscape. By
                gaining a deep insight into your specific needs, we craft
                personalized strategies that harness the power of technology to
                propel your business forward.
              </p>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="assistDataWrap">
                  <h5>Creation of a Comprehensive IT Strategy</h5>
                  <p>
                    We begin by understanding your business objectives and
                    challenges. Our experienced consultants collaborate with
                    your team to create a comprehensive IT strategy aligned with
                    your long-term goals.
                  </p>
                </div>
                <div className="assistDataWrap">
                  <h5>Implementation of IT Strategy</h5>
                  <p>
                    Executing the IT strategy is a critical phase. Our team
                    ensures seamless integration of technology solutions and
                    processes, minimizing disruptions and maximizing the return
                    on your IT investments.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="assistImgWrap">
                  <img src={itconsultancy1} alt="VNT Client Assists" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="assistDataWrap">
                  <h5>Constant Performance Measurement</h5>
                  <p>
                    Continuous monitoring and performance measurement are
                    essential for the success of any IT strategy. We analyze key
                    metrics and provide regular reports to evaluate the
                    effectiveness of implemented solutions.
                  </p>
                </div>
                <div className="assistDataWrap">
                  <h5>Suggestions for Improvements</h5>
                  <p>
                    Version Next Technologies believes in ongoing improvement.
                    Based on performance evaluations, we provide valuable
                    insights and recommendations to optimize your IT
                    infrastructure and further enhance business outcomes.
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="assistImgWrap">
                  <img src={itconsultancy2} alt="VNT Client Assists" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="whatMakesSection lessPad" id="whatMakesSection">
          <DevDiff
            float1={float1}
            float2={float2}
            Char1="Partner with"
            Char2="VNT"
            Char3="for IT Consultancy Solutions"
            diffDescription="As you step into the world of IoT, Version Next Technologies is your trusted companion. We offer end-to-end IoT development services, ensuring a seamless journey from ideation to deployment and beyond. Embrace innovation, maximize efficiency, and unleash the potential of IoT with Version Next Technologies by your side. "
            diffDescription2="Reach out to us today to embark on a transformative IoT journey that will shape the future of your business."
          />
        </section>
        <section className="IndusExpertSection">
          <IndusExpert
            cName="Version Next Technologies"
            cSecTitle="Version Next Technologies as your IT Consulting partner, you can expect"
            profileName="Mr. Sanyogg Shelar"
            designation="Buisness Head"
            cardTitle1="Expertise and Innovation"
            cardData1="Access the best minds in the IoT industry and harness the power of innovative technologies to bring your ideas to life."
            cardTitle2="Customized Solutions"
            cardData2="We don't believe in one-size-fits-all solutions. Our team tailors each IoT project to suit your specific business needs and requirements."
            cardTitle3="Timely Delivery"
            cardData3="We understand the importance of time-to-market. Version Next is committed to delivering your IoT solution within agreed timelines without compromising on quality."
            cardTitle4="Transparent Communication"
            cardData4="Stay updated throughout the development process with our transparent and efficient communication channels."
            profileImg={sanyogprofileImg}
            facebookLink="https://profiles.wordpress.org/codexdemon/"
            facebookIcon="fab fa-wordpress"
            twiiterLink="https://twitter.com/sanyog"
            twitterIcon="fab fa-twitter-square"
            linkdinLink="https://www.linkedin.com/in/sanyogs"
            linkdinIcon="fab fa-linkedin"
          />
        </section>
        <BlogSection />
      </div>
    </>
  );
}

export default ItConsultancy;
